<template>
  <div class="preview">
    <img
      v-if="file && isNewImage()"
      :src="file"
      class="preview-img"
      >

    <embed
      v-if="file && isNewPdf()"
      :src="file"
      class="preview-pdf">

    <img
      v-if="file === '' && map && isImage()"
      :src="mapUrl"
      class="preview-img"
      >

    <object
      v-if="file === '' && map && isPdf()"
      :data="mapUrl"
      type="application/pdf"
      class="preview-pdf"
      >
    </object>
  </div>
</template>

<script>

export default {
  props: {
    file: {
      type: String
    },

    fileType: {
      type: String
    }
  },

  computed: {
    map: function () {
      return this.$store.state.quizset.map
    },

    // TODO 苦肉の策 → どうにかしたい
    mapUrl: function () {
      let url = this.map.url()
      if (url && process.env.NODE_ENV === 'production') {
        url = url.replace(/^http:/, 'https:')
      }
      return url
    },
  },

  methods: {
    isNewImage: function () {
      const imageTypes = ['png', 'jpeg']
      return imageTypes.some((t) => {
        return this.fileType.includes(t)
      })
    },

    isNewPdf: function () {
      return this.fileType.includes('pdf')
    },

    isImage: function () {
      const imageTypes = ['png', 'jpeg']
      return imageTypes.some((t) => {
        return this.map.name().includes(t)
      })
    },

    isPdf: function () {
      return this.map.name().includes('pdf')
    }
  }
}
</script>

<style lang="scss" scoped>
.preview {
  text-align: center;
  &-img {
    width: 80%;
    object-fit: contain;
  }

  &-pdf {
    width: 80%;
    height: 500px;
  }
}
</style>
